module.exports = __webpack_public_path__ + "img/genai2.450980c4.png";